module.exports = __webpack_public_path__ + "static/media/moyenstanding1.c9d00f3d.jpg";